import React, {Component, ReactElement} from 'react'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {
    NatGetRegistrationApplyListRequest,
    NatGetRegistrationApplyListResponse,
    ResidentUserRegistrationApplyInfo,
} from '../roomToResident/repository/NatGetRegistrationApplyList'
import {SortOrder} from '../../../components/shared/SortOrder'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay'
import {Messages} from '../../../Messages'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {NatGetRidge, RidgeData} from '../ridge/repository/NatGetRidge'
import {CondominiumGroupData, NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {
    ADMINISTORATOR_MODE,
    RESIDENT_USER_REGISTRATION_APPLY_CATEGORY,
    RESIDENT_USER_REGISTRATION_APPLY_STATUS,
} from '../../../CodeMaster'
import PPCheckboxGroup, {PPCheckboxProp} from '../../../components/shared/forms/PPCheckboxGroup'
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody'
import {Link, SortDirection, TableCell, TableRow} from '@mui/material'
import {formatDateTimeForUpdateDate, formatForDateInput} from '../../../formatters/formatDate'
import {PreLineTableCell} from '../facilityReserve/NatFacilityReserveListPage'
import {addEmptyData} from '../../../componentHelper/selectHelper'
import {flipSortDirection} from '../../../components/shared/SortDirectionHelper'
import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea'
import {judgeAuthorityCheck} from '../../common/util/Natutil'
import {HKConstants} from '../../../HKConstants'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper
} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper';
import {SelectChangeEvent} from '@mui/material/Select'
import {Location} from 'react-router-dom'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents';
import PPDatePicker from '../../../components/shared/forms/PPDatePicker';
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions';
import styled from 'styled-components';
import moment from 'moment/moment';
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo';

const KEY_RESIDENT_USER_APPLY_LIST_SEARCH_CONDITION: string = 'adminResidentUserApplyListPageSearchCondition'

interface Props {
    currentDateTimeRepo: NatCurrentDateTimeRepo
    roomToResidentRepo: NatRoomToResidentRepo
    ridgeRepo: NatRidgeRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    ridgeInfo: RidgeData[]
    condominiumGroup: Nullable<CondominiumGroupData>
    residentUserRegistrationApplyInfoList: ResidentUserRegistrationApplyInfo[]
    ridgeCd: string
    roomNumber: string
    applyStatus: string[]
    condominiumGroupId: number | null
    condominiumCd: string
    condominiumName: string
    applyStartDate: string
    applyEndDate: string
    sortInfo: SortOrder[]
    total: number
    page: number
    pageNum: number
    registrationApplyListRequest: NatGetRegistrationApplyListRequest
    isLoadCompleted: boolean
}

interface LastSearchCondition {
    ridgeCd?: string
    roomNumber?: string
    applyStatus?: string[]
    condominiumGroupId?: number | null
    condominiumCd?: string
    condominiumName?: string
    applyStartDate?: string
    applyEndDate?: string
    pageNum?: number
}

class NatAdminResidentUserApplyList extends Component<Props & AdminPagePropsSet, States> {
    lastSearchCondition: LastSearchCondition
    selectedCondominiumCd: Nullable<string>
    mode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.lastSearchCondition = this.getLastSearchCondition()
        this.selectedCondominiumCd = SessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD)
        this.mode = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.SELECTED_MODE)

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID)

        const defaultSearchConditionRidgeCd =
            this.getLastSearchConditionOrNull('ridgeCd') || ''
        const defaultSearchConditionRoomNumber =
            this.getLastSearchConditionOrNull('roomNumber') || ''
        const defaultSearchConditionApplyStatus =
            this.getLastSearchConditionOrNull('applyStatus') ||
            (this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value ?
                [
                    RESIDENT_USER_REGISTRATION_APPLY_STATUS.APPLYING.value,
                    RESIDENT_USER_REGISTRATION_APPLY_STATUS.CONFIRMING.value,
                    RESIDENT_USER_REGISTRATION_APPLY_STATUS.APPROVED.value,
                ] : [])
        const defaultSearchConditionCondominiumGroupId =
            this.getLastSearchConditionOrNull('condominiumGroupId') ||
            (this.mode === ADMINISTORATOR_MODE.ALL.value ?
                loginUserCondominiumGroupId : null)
        const defaultSearchConditionCondominiumCd =
            this.getLastSearchConditionOrNull('condominiumCd') || ''
        const defaultSearchConditionCondominiumName =
            this.getLastSearchConditionOrNull('condominiumName') || ''
        const defaultSearchConditionPageNum =
            this.getLastSearchConditionOrNull('pageNum') || COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0]

        this.state = {
            ridgeInfo: [],
            condominiumGroup: null,
            residentUserRegistrationApplyInfoList: [],
            ridgeCd: defaultSearchConditionRidgeCd,
            roomNumber: defaultSearchConditionRoomNumber,
            applyStatus: defaultSearchConditionApplyStatus,
            condominiumGroupId: defaultSearchConditionCondominiumGroupId,
            condominiumCd: defaultSearchConditionCondominiumCd,
            condominiumName: defaultSearchConditionCondominiumName,
            applyStartDate: '',
            applyEndDate: '',
            sortInfo: [new SortOrder('applyStatus', 'asc'), new SortOrder('applyId', 'desc')],
            total: 0,
            page: COMMON_CONSTANTS.FIRST_PAGE,
            pageNum: defaultSearchConditionPageNum,
            registrationApplyListRequest: {
                ridgeCd: defaultSearchConditionRidgeCd,
                roomNumber: defaultSearchConditionRoomNumber,
                status: defaultSearchConditionApplyStatus,
                condominiumGroupId: defaultSearchConditionCondominiumGroupId,
                condominiumCd: defaultSearchConditionCondominiumCd,
                condominiumName: defaultSearchConditionCondominiumName,
                applyStartDate: '',
                applyEndDate: '',
                pageNum: defaultSearchConditionPageNum,
                sortInfo: [new SortOrder('applyStatus', 'asc'), new SortOrder('applyId', 'desc')],
                page: COMMON_CONSTANTS.FIRST_PAGE,
            },
            isLoadCompleted: false,
        }
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.getApplyList = this.getApplyList.bind(this)
        this.judgeCheckStatus = this.judgeCheckStatus.bind(this)
        this.onChangeRidgeCd = this.onChangeRidgeCd.bind(this)
        this.onChangeRoomNumber = this.onChangeRoomNumber.bind(this)
        this.onChangeApplyStatus = this.onChangeApplyStatus.bind(this)
        this.onChangeCondominiumGroupId = this.onChangeCondominiumGroupId.bind(this)
        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onChangeApplyStartDate = this.onChangeApplyStartDate.bind(this)
        this.onChangeApplyEndDate = this.onChangeApplyEndDate.bind(this)
        this.handleSortMessages = this.handleSortMessages.bind(this)
        this.onClickRegisterButton = this.onClickRegisterButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            if (this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value) {
                await this.getRidge()
                await this.getApplyStartDateAndApplyEndDate()
            } else {
                await this.getCondominiumGroup()
            }
            await this.getApplyList(this.state.registrationApplyListRequest)
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    getLastSearchCondition(): LastSearchCondition {
        let lastSearchCondition: LastSearchCondition = {}
        const sessionStorageSearchCondition: string | null =
            SessionStorageHelper.getStringItemOrNull(KEY_RESIDENT_USER_APPLY_LIST_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        }
        return lastSearchCondition
    }

    getLastSearchConditionOrNull<U extends keyof LastSearchCondition>(key: U): Nullable<LastSearchCondition[U]> {
        if (this.lastSearchCondition[key] !== undefined) {
            return this.lastSearchCondition[key]
        }
        return null
    }

    saveLastSearchCondition(lastSearchCondition: LastSearchCondition): void {
        SessionStorageHelper.setItem(KEY_RESIDENT_USER_APPLY_LIST_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        const registrationApplyListRequest = this.state.registrationApplyListRequest
        registrationApplyListRequest.pageNum = Number(event.target.value)
        registrationApplyListRequest.page = COMMON_CONSTANTS.FIRST_PAGE

        await this.searchApplyList(registrationApplyListRequest)

        this.setState({
            registrationApplyListRequest: registrationApplyListRequest,
            pageNum: Number(event.target.value),
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }, () => {
            this.props.eventEmitter.scrollToContentsTop()
            this.saveLastSearchCondition({
                ridgeCd: registrationApplyListRequest.ridgeCd,
                roomNumber: registrationApplyListRequest.roomNumber,
                applyStatus: registrationApplyListRequest.status,
                condominiumGroupId: registrationApplyListRequest.condominiumGroupId,
                condominiumCd: registrationApplyListRequest.condominiumCd,
                condominiumName: registrationApplyListRequest.condominiumName,
                pageNum: registrationApplyListRequest.pageNum,
            })
        })
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()

        const registrationApplyListRequest = this.state.registrationApplyListRequest
        registrationApplyListRequest.page = newPage

        await this.searchApplyList(registrationApplyListRequest)

        this.setState({
            registrationApplyListRequest: registrationApplyListRequest,
            page: newPage,
        }, () => {
            this.props.eventEmitter.scrollToContentsTop()
        })
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()

        const registrationApplyListRequest = this.state.registrationApplyListRequest
        registrationApplyListRequest.ridgeCd = this.state.ridgeCd
        registrationApplyListRequest.roomNumber = this.state.roomNumber
        registrationApplyListRequest.status = this.state.applyStatus
        registrationApplyListRequest.condominiumGroupId = this.state.condominiumGroupId
        registrationApplyListRequest.condominiumCd = this.state.condominiumCd
        registrationApplyListRequest.condominiumName = this.state.condominiumName
        registrationApplyListRequest.applyStartDate = this.state.applyStartDate
        registrationApplyListRequest.applyEndDate = this.state.applyEndDate
        registrationApplyListRequest.page = COMMON_CONSTANTS.FIRST_PAGE

        await this.searchApplyList(registrationApplyListRequest)

        this.setState({
            registrationApplyListRequest: registrationApplyListRequest,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }, () => {
            this.props.eventEmitter.scrollToContentsTop()
            this.saveLastSearchCondition({
                ridgeCd: registrationApplyListRequest.ridgeCd,
                roomNumber: registrationApplyListRequest.roomNumber,
                applyStatus: registrationApplyListRequest.status,
                condominiumGroupId: registrationApplyListRequest.condominiumGroupId,
                condominiumCd: registrationApplyListRequest.condominiumCd,
                condominiumName: registrationApplyListRequest.condominiumName,
                applyStartDate: registrationApplyListRequest.applyStartDate,
                applyEndDate: registrationApplyListRequest.applyEndDate,
                pageNum: registrationApplyListRequest.pageNum,
            })
        })
    }

    onClickRegisterButton(): void {
        this.props.navigate(
            '/admin/residentUser/apply',
        )
    }

    async searchApplyList(request: NatGetRegistrationApplyListRequest): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getApplyList({...request, sortInfo: this.convertSortKeyOfName(request.sortInfo)})
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    convertSortKeyOfName(sortInfoList: SortOrder[]): SortOrder[] {
        return sortInfoList.flatMap(sortInfo => {
            if (sortInfo.sortKey === 'applyUserName') {
                return [
                    new SortOrder('applyUserFamilyName', sortInfo.sortDirection),
                    new SortOrder('applyUserFirstName', sortInfo.sortDirection),
                ]
            }

            if (sortInfo.sortKey === 'approveUserName') {
                return [
                    new SortOrder('approveUserFamilyName', sortInfo.sortDirection),
                    new SortOrder('approveUserFirstName', sortInfo.sortDirection),
                ]
            }

            return [new SortOrder(sortInfo.sortKey, sortInfo.sortDirection)]
        })
    }

    async getApplyStartDateAndApplyEndDate(): Promise<void> {
        const currentDateTime = await this.props.currentDateTimeRepo.getCurrentDateTime()
        if (currentDateTime && currentDateTime.details) {
            const currentDate = moment(`${currentDateTime.details.currentDateTime}`)
            const defaultApplyStartDate =
                this.getLastSearchConditionOrNull('applyStartDate') ?? currentDate.clone().subtract(1, 'month').format('YYYY-MM-DD')
            const defaultApplyEndDate =
                this.getLastSearchConditionOrNull('applyEndDate') ?? currentDate.format('YYYY-MM-DD')
            const registrationApplyListRequest = this.state.registrationApplyListRequest
            registrationApplyListRequest.applyStartDate = defaultApplyStartDate
            registrationApplyListRequest.applyEndDate = defaultApplyEndDate

            this.setState({
                applyStartDate: defaultApplyStartDate,
                applyEndDate: defaultApplyEndDate,
                registrationApplyListRequest: registrationApplyListRequest,
            })
        }
    }

    async getRidge(): Promise<void> {
        const ridge: Nullable<NatGetRidge> = await this.props.asyncCallFunction(
            this.props.ridgeRepo.getRidgeList.bind(this.props.ridgeRepo, this.selectedCondominiumCd ?
                this.selectedCondominiumCd : undefined),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (ridge && ridge.details) {
            this.setState({ridgeInfo: ridge.details})
        }
    }

    async getCondominiumGroup(): Promise<void> {
        const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
            this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (condominiumGroupResponse && condominiumGroupResponse.details) {
            this.setState({condominiumGroup: condominiumGroupResponse.details})
        }
    }

    async getApplyList(request: NatGetRegistrationApplyListRequest): Promise<void> {
        const registrationApply: Nullable<NatGetRegistrationApplyListResponse> =
            await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.getResidentUserApplyList.bind(
                    this.props.roomToResidentRepo,
                    request,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
        if (registrationApply && registrationApply.details) {
            this.setState({
                residentUserRegistrationApplyInfoList: registrationApply.details.residentUserRegistrationApplyInfo,
                total: registrationApply.details.searchResult.total,
            })
        }
    }

    convertRidgeIntoOptionProps(): OptionProps[] {
        const optionProps: OptionProps[] = this.state.ridgeInfo.map((ridge) => {
            return ({
                label: `${ridge.ridgeCd} : ${ridge.ridgeName}`,
                value: `${ridge.ridgeCd}`,
            })
        })
        return optionProps
    }

    getApplyStatus(): PPCheckboxProp[] {
        const applyStatus: RESIDENT_USER_REGISTRATION_APPLY_STATUS[] =
            RESIDENT_USER_REGISTRATION_APPLY_STATUS.values()
                .filter(status => status !== RESIDENT_USER_REGISTRATION_APPLY_STATUS.REJECTION)

        return applyStatus.map(status => ({
            label: status.label,
            checked: this.judgeCheckStatus(status.value),
        }))
    }

    judgeCheckStatus(status: string): boolean {
        if (!this.state.applyStatus) {
            return false
        }
        return this.state.applyStatus.includes(status)
    }


    searchResults(): SearchResultCountDisplayProps {
        if (this.state.residentUserRegistrationApplyInfoList.length === 0) {
            return {noResultMessage: Messages.IOPCC0014.toString('')}
        }

        return {
            totalCount: this.state.total,
            rowsPerPage: this.state.pageNum,
            page: this.state.page,
        }
    }

    onChangeRidgeCd(event: SelectChangeEvent<unknown>): void {
        let ridgeCd: string = event.target.value as string
        if (ridgeCd === 'none') {
            ridgeCd = ''
        }
        this.setState({ridgeCd: ridgeCd})
    }

    onChangeRoomNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({roomNumber: event.target.value})
    }

    onChangeApplyStatus(label: string, checked: boolean): void {
        const checkedStatus = RESIDENT_USER_REGISTRATION_APPLY_STATUS.values()
            .filter(status => status.label === label)
            .map(status => status.value)[0]

        const applyStatus = this.state.applyStatus
        let updated: string[]
        if (applyStatus) {
            if (checked) {
                updated = [...applyStatus, checkedStatus]
            } else {
                updated = [...applyStatus].filter(status => status !== checkedStatus)
            }
            this.setState({applyStatus: updated})
        } else {
            if (checked) {
                this.setState({applyStatus: [checkedStatus]})
            }
        }
    }

    onChangeCondominiumGroupId(condominiumGroupId: number): void {
        this.setState({condominiumGroupId})
    }

    onChangeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({condominiumCd: event.target.value})
    }

    onChangeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({condominiumName: event.target.value})
    }

    onChangeApplyStartDate(date: Nullable<Date>): void {
        this.setState({applyStartDate: date ? formatForDateInput(date.toString()) : ''})
    }

    onChangeApplyEndDate(date: Nullable<Date>): void {
        this.setState({applyEndDate: date ? formatForDateInput(date.toString()) : ''})
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.sortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    async handleSortMessages(sortKey: string): Promise<void> {
        this.beforeUserAction()

        const sortInfo: SortOrder[] = [
            new SortOrder(
                sortKey,
                flipSortDirection(this.getSortDirection(sortKey),
                    'desc')),
        ]
        const registrationApplyListRequest = this.state.registrationApplyListRequest
        registrationApplyListRequest.sortInfo = sortInfo
        registrationApplyListRequest.page = COMMON_CONSTANTS.FIRST_PAGE

        await this.searchApplyList(registrationApplyListRequest)

        this.setState({
            registrationApplyListRequest: registrationApplyListRequest,
            page: COMMON_CONSTANTS.FIRST_PAGE,
            sortInfo: sortInfo,
        })
    }

    renderApplyInfoTable(): Nullable<ReactElement> {
        if (this.state.residentUserRegistrationApplyInfoList.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {
                id: 'applyId',
                label: '申請番号',
                sortable: true,
                direction: this.getSortDirection('applyId'),
            }]
        if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
            headers.push(
                {id: 'condominiumGroupName', label: '物件グループ'},
                {id: 'condominiumName', label: '物件名'},
            )
        }
        headers.push(
            {id: 'roomNumber', label: '部屋番号'},
            {
                id: 'applyCategory',
                label: '申請区分',
                sortable: true,
                direction: this.getSortDirection('applyCategory'),
            },
            {
                id: 'applyStatus',
                label: 'ステータス',
                sortable: true,
                direction: this.getSortDirection('applyStatus'),
            },
            {
                id: 'applyUserName',
                label: '申請者',
                sortable: true,
                direction: this.getSortDirection('applyUserName'),
            },
            {
                id: 'applyDatetime',
                label: '申請日時',
                sortable: true,
                direction: this.getSortDirection('applyDatetime'),
            },
        )
        if (this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value) {
            headers.push(
                {
                    id: 'approveUserName',
                    label: '承認者',
                    sortable: true,
                    direction: this.getSortDirection('approveUserName'),
                },
                {
                    id: 'approveDatetime',
                    label: '承認日時',
                    sortable: true,
                    direction: this.getSortDirection('approveDatetime'),
                },
            )
        }

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.total,
                    rowsPerPage: this.state.pageNum,
                    page: this.state.page,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    headers={headers}
                    onSortOrderChange={this.handleSortMessages}
                />
                <SortablePaginationTableBody>
                    {this.state.residentUserRegistrationApplyInfoList.map(
                        (residentUserRegistrationApplyInfo, index) =>
                            this.renderResidentUserRegistrationApplyRecord(residentUserRegistrationApplyInfo, index),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    renderResidentUserRegistrationApplyRecord(
        residentUserRegistrationApplyInfo: ResidentUserRegistrationApplyInfo,
        rowNum: number,
    ): ReactElement {
        const {
            applyId,
            condominiumGroupName,
            condominiumName,
            ridgeName,
            roomNumber,
            applyCategory,
            applyStatus,
            applyUserFamilyName,
            applyUserFirstName,
            applyDatetime,
            approveUserFamilyName,
            approveUserFirstName,
            approveDatetime,
        } = residentUserRegistrationApplyInfo
        let viewApproveDatetime: string = ''
        if (approveDatetime) {
            viewApproveDatetime = formatDateTimeForUpdateDate(approveDatetime)
        }
        return (
            <TableRow key={rowNum}>
                {residentUserRegistrationApplyInfo.applyCategory ===
                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.NOTICE_REISSUE.value ?
                    <>
                        <PreLineTableCell align={'center'}>
                            {/*認証キー通知状発行申請の連番seqもレスポンスのapplyIdで受け取っているためapplyIdをパラメータとして使用*/}
                            <Link href={`/admin/residentUser/noticeApply/${applyId}`} underline="hover">{applyId}</Link>
                        </PreLineTableCell>
                    </> :
                    <>
                        <PreLineTableCell align={'center'}>
                            <Link href={`/admin/residentUser/apply/${applyId}`} underline="hover">{applyId}</Link>
                        </PreLineTableCell>
                    </>
                }
                {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                    <>
                        <TableCell align={'center'}>
                            {condominiumGroupName}
                        </TableCell>
                        <TableCell align={'center'}>
                            {condominiumName}
                        </TableCell>
                    </>
                }
                <PreLineTableCell align={'center'}>
                    {ridgeName} {roomNumber}
                </PreLineTableCell>
                <TableCell align={'center'}>
                    {RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.codeToEnumConstants(applyCategory).label}
                </TableCell>
                <TableCell align={'center'}>
                    {RESIDENT_USER_REGISTRATION_APPLY_STATUS.codeToEnumConstants(applyStatus).label}
                </TableCell>
                <TableCell align={'center'}>
                    {applyUserFamilyName} {applyUserFirstName}
                </TableCell>
                <TableCell align={'center'}>
                    {formatDateTimeForUpdateDate(applyDatetime)}
                </TableCell>
                {this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value &&
                    <>
                        <TableCell align={'center'}>
                            {approveUserFamilyName} {approveUserFirstName}
                        </TableCell>
                        <TableCell align={'center'}>
                            {viewApproveDatetime}
                        </TableCell>
                    </>
                }
            </TableRow>
        )
    }

    renderConditionTable(): Nullable<ReactElement> {
        if (this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value) {
            return this.renderConditionTableForCondominiumMode()
        } else {
            return this.renderConditionTableForAllMode()
        }
    }

    renderSearchButton(): Nullable<ReactElement> {
        return (
            <ConditionButtonCell>
                <AdminDefaultMediumButton
                    onClick={this.onClickSearchButton}>
                    居住者ユーザ申請を検索する
                </AdminDefaultMediumButton>
            </ConditionButtonCell>
        )
    }

    renderConditionTableForCondominiumMode(): Nullable<ReactElement> {
        return (
            <ConditionTable>
                <ConditionTableBody>
                    <ConditionTableRow>
                        <ConditionCategoryCell rowSpan={2}>物件情報</ConditionCategoryCell>
                        <ConditionColumNameCell>棟名</ConditionColumNameCell>
                        <ConditionInputCell>
                            <PPSelect
                                fullWidth
                                data={addEmptyData(this.convertRidgeIntoOptionProps())}
                                onChange={this.onChangeRidgeCd}
                                value={this.state.ridgeCd}
                                autoFocus
                            />
                        </ConditionInputCell>
                        <ConditionButtonCell></ConditionButtonCell>
                    </ConditionTableRow>
                    <ConditionTableRow>
                        <ConditionColumNameCell>部屋番号</ConditionColumNameCell>
                        <ConditionInputCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 4,
                                    },
                                }}
                                fullWidth
                                onChange={this.onChangeRoomNumber}
                                defaultValue={this.state.roomNumber}
                            />
                        </ConditionInputCell>
                        <ConditionButtonCell></ConditionButtonCell>
                    </ConditionTableRow>
                    <ConditionTableRow>
                        <ConditionCategoryCell rowSpan={2}>申請情報</ConditionCategoryCell>
                        <ConditionColumNameCell>申請日</ConditionColumNameCell>
                        <ConditionInputCell colSpan={2}>
                            <LeftRowFlexContainer>
                                <TermWrapper>
                                    <FlexBasis>
                                        <PPDatePicker
                                            onChangeDate={this.onChangeApplyStartDate}
                                            value={this.state.applyStartDate !== '' ?
                                                new Date(this.state.applyStartDate) : null}
                                            maxDate={this.state.applyEndDate !== '' ?
                                                new Date(this.state.applyEndDate) : undefined}
                                        />
                                    </FlexBasis>
                                    <TermTxt>から</TermTxt>
                                </TermWrapper>
                                <TermWrapper>
                                    <FlexBasis>
                                        <PPDatePicker
                                            onChangeDate={this.onChangeApplyEndDate}
                                            value={this.state.applyEndDate !== '' ?
                                                new Date(this.state.applyEndDate) : null}
                                            minDate={this.state.applyStartDate !== '' ?
                                                new Date(this.state.applyStartDate) : undefined}
                                        />
                                    </FlexBasis>
                                    <TermTxt>まで</TermTxt>
                                </TermWrapper>
                            </LeftRowFlexContainer>
                        </ConditionInputCell>
                    </ConditionTableRow>
                    <ConditionTableRow>
                        <ConditionColumNameCell>ステータス</ConditionColumNameCell>
                        <ConditionInputCell colSpan={2}>
                            <PPCheckboxGroup
                                row
                                data={this.getApplyStatus()}
                                onChangeChecked={this.onChangeApplyStatus}
                            />
                        </ConditionInputCell>
                        {this.renderSearchButton()}
                    </ConditionTableRow>
                </ConditionTableBody>
            </ConditionTable>
        )
    }

    renderConditionTableForAllMode(): Nullable<ReactElement> {
        return (
            <ConditionTable>
                <ConditionTableBody>
                    <ConditionTableRow>
                        <ConditionCategoryCell rowSpan={3}>物件情報</ConditionCategoryCell>
                        <ConditionColumNameCell>物件グループ</ConditionColumNameCell>
                        <ConditionInputCell>
                            {
                                this.state.condominiumGroup &&
                                <>
                                    <NatCondominiumGroupSelectComponent
                                        condominiumGroup={this.state.condominiumGroup}
                                        onChangeSelectedCondominiumGroupId=
                                            {this.onChangeCondominiumGroupId}
                                        defaultValue={(this.state.condominiumGroupId) ?
                                            this.state.condominiumGroupId : null}
                                        requiredFlag={true}
                                        eventKeys={['condominiumGroupId']}
                                        eventEmitter={this.props.eventEmitter}
                                        autoFocus={true}
                                    >
                                    </NatCondominiumGroupSelectComponent>
                                </>
                            }
                        </ConditionInputCell>
                        <ConditionButtonCell></ConditionButtonCell>
                    </ConditionTableRow>
                    <ConditionTableRow>
                        <ConditionColumNameCell>物件コード</ConditionColumNameCell>
                        <ConditionInputCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 6,
                                    },
                                }}
                                fullWidth
                                onChange={this.onChangeCondominiumCd}
                                defaultValue={this.state.condominiumCd}
                            />
                        </ConditionInputCell>
                        <ConditionButtonCell></ConditionButtonCell>
                    </ConditionTableRow>
                    <ConditionTableRow>
                        <ConditionColumNameCell>物件名</ConditionColumNameCell>
                        <ConditionInputCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 50,
                                    },
                                }}
                                fullWidth
                                onChange={this.onChangeCondominiumName}
                                defaultValue={this.state.condominiumName}
                            />
                        </ConditionInputCell>
                        {this.renderSearchButton()}
                    </ConditionTableRow>
                </ConditionTableBody>
            </ConditionTable>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                    onEnterKey={this.onClickSearchButton}
                >
                    {this.renderConditionTable()}
                </ListSearchFormArea>
                {judgeAuthorityCheck(HKConstants.CMN.AUTH.APPLY_RESIDENT_USER) &&
                    <SearchPageActionArea>
                        <AdminDefaultMediumButton onClick={this.onClickRegisterButton}>
                            新規
                        </AdminDefaultMediumButton>
                    </SearchPageActionArea>
                }
                <PageMainArea>
                    {this.renderApplyInfoTable()}
                </PageMainArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminResidentUserApplyList)

const FlexBasis: StyledDiv = styled.div`
 flex: 1 1 0;
`;

const TermWrapper: StyledDiv = styled.div`
 display: flex;
 flex: 1 1 auto;
 align-items: flex-end;
`;

const TermTxt: StyledSpan = styled.span`
 padding: 0 5px 0 5px;
`;
